<script>
    import { onMount } from 'svelte';
    import { TRACKING_PROPERTIES_KEY, RESULT_MAPPING_KEY } from '$lib/global/constants';
    import getQueryParameter from '$lib/global/helper/get-query-parameter';
    import { setTrackingProperty } from '$lib/helper';

    export let resultPages = [];
    export let campaignId = '';

    // This happens only on refresh/initial load of the funnel
    // since the component only mounts once in layout
    onMount(() => {
        const ST = window.sessionStorage;
        const ResultMappingKey = `${RESULT_MAPPING_KEY}${campaignId}`;
        const TrackingPropertiesKey = `${TRACKING_PROPERTIES_KEY}${campaignId}`;

        // Init Result mapping
        const pageCounts = {};
        resultPages.forEach((resultPage) => {
            pageCounts[resultPage] = 0;
        });
        ST.setItem(ResultMappingKey, JSON.stringify(pageCounts));

        // Init Tracking properties (personalization)
        const queryParams = getQueryParameter();
        ST.setItem(TrackingPropertiesKey, JSON.stringify({}));
        Object.keys(queryParams.custom).forEach((param) => {
            setTrackingProperty(param, queryParams.custom[param], campaignId);
        });
    });
</script>
